import {Logger} from '#core/utils/logger.js';

import {DBXAbstractPerformanceLogger} from '#core/services/performance-reporting-service/abstract-performance-logger.js';
import {DBXPerformanceService, METRIC} from '#core/services/performance-reporting-service/index.js';
import {getCollectedTime} from '#core/services/performance-reporting-service/utils.js';

const logger = Logger('Lifecycle');

const TIMEOUT = 20 * 1000; // 20 seconds

class AppLoadedNotifier extends DBXAbstractPerformanceLogger {
    reportTiming(name) {
        if (name === METRIC.INITIAL_PAGE_READY || name === METRIC.INITIAL_PAGE_INTERACTED_BEFORE_READY) {
            setTimeout(notifyAppIsLoaded, 0);
        }
    }

    wsActivityMostlyFinished() {
        // Called when websocket activity is mostly finished
        // We treat it as lotto loaded
        DBXPerformanceService.reportDuration(METRIC.MOJ_TIMINGS_GET_CONFIG_DURATION, getCollectedTime('getConfig'));

        setTimeout(notifyAppIsLoaded, 0);
    }
}

let appLoadedListener = null;
export function setAppLoadedListener(handler) {
    appLoadedListener = handler;
}

//===========================================
let triggered = false;
let timer = null;
let promiseResolve = null;
export function notifyAppIsLoaded() {
    if (triggered) return;
    try {
        triggered = true;
        logger.debug(`${PRODUCT_NAME} loaded.`);
        performance.mark(`dbx:${PRODUCT_NAME}:loaded`);
        clearTimeout(timer);

        if (promiseResolve) promiseResolve();
        if (appLoadedListener) appLoadedListener();
    } catch (e) {
        logger.warn(`Failed to to notify about application loaded": ${e.message}`);
    }
}

export function createAppLoadedNotifier() {
    cancelAppLoadedNotifier();

    timer = setTimeout(notifyAppIsLoaded, TIMEOUT);

    return new Promise(resolve => {
        promiseResolve = resolve;
    });
}

export function cancelAppLoadedNotifier() {
    clearTimeout(timer);
    timer = null;
    triggered = false;
}

DBXPerformanceService.addLogger(new AppLoadedNotifier());
